/**
 * Bounty form copy constants.
 *
 * User-facing helper text for the bounty create/edit form
 * (pages/bounty/BountyCreateEdit.tsx): reward, title, and description hints
 * plus the empty-state text for the image picker.
 */
export const bountyRewardMessage = "only charged when you accept a submission";
export const bountyDescriptionMessage =
    "be as specific as possible here, especially with size and condition. it will result in better quality submissions";
export const bountyTitleMessage = "the most defining features";
export const bountyImageEmptyText =
    "add images of the item itself, an item like it, what you're trying to match it with, etc...\n" +
    "if you don't have images, your description has to be sublime";
